/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Registrationnotfounderror3Inputs */

const en_registrationnotfounderror3 = /** @type {(inputs: Registrationnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-up no longer exists.`)
};

const de_registrationnotfounderror3 = /** @type {(inputs: Registrationnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Anmeldung gibt es nicht mehr.`)
};

/**
* | output |
* | --- |
* | "This sign-up no longer exists." |
*
* @param {Registrationnotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const registrationnotfounderror3 = /** @type {((inputs?: Registrationnotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registrationnotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_registrationnotfounderror3(inputs)
	return de_registrationnotfounderror3(inputs)
});
export { registrationnotfounderror3 as "registrationNotFoundError" }